import React from 'react';
import { Building, FileText } from 'lucide-react';

/**
 * Компонент секции долгосрочных активов для формы расчета ликвидности
 */
const LongTermAssetsSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-green-50 dark:bg-green-900/20 p-5 rounded-lg border border-green-200 dark:border-green-800">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Building className="w-5 h-5 mr-2 text-green-600" />
        Внеоборотные активы
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Внеоборотные активы (общая сумма) */}
        <div className="md:col-span-2">
          <label htmlFor="longTermAssets.nonCurrentAssets" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Building className="w-4 h-4 mr-1.5 text-green-600" />
            Всего внеоборотных активов
          </label>
          <input
            type="text"
            id="longTermAssets.nonCurrentAssets"
            name="longTermAssets.nonCurrentAssets"
            value={formData.longTermAssets.nonCurrentAssets}
            onChange={handleInputChange}
            className={`form-input w-full ${errors['longTermAssets.nonCurrentAssets'] ? 'input-error' : ''}`}
            placeholder="0"
          />
          {errors['longTermAssets.nonCurrentAssets'] && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors['longTermAssets.nonCurrentAssets']}
            </p>
          )}
        </div>
      </div>

      {/* Информационная подсказка */}
      <div className="mt-4 bg-green-100 dark:bg-green-900/40 p-3 rounded-lg border border-green-200 dark:border-green-800">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <FileText className="h-5 w-5 text-green-600 dark:text-green-400" />
          </div>
          <div className="ml-3">
            <h4 className="text-sm font-medium text-green-800 dark:text-green-200">
              Что включать во внеоборотные активы
            </h4>
            <p className="mt-1 text-xs text-green-700 dark:text-green-300">
              К внеоборотным активам согласно РСБУ относятся: нематериальные активы, основные средства, доходные вложения в материальные ценности, финансовые вложения (долгосрочные), отложенные налоговые активы и прочие внеоборотные активы.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LongTermAssetsSection;